import {generalRequest} from "../services";

export async function apiPostUserReport(data) {
    return generalRequest.post(`user_report`, data)
}